"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ActionTypes = _interopRequireDefault(require("composer-lib/redux/ActionTypes"));

var _UISettings = _interopRequireDefault(require("composer-lib/data/model/UISettings"));

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _UISettings.default();
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.default.SHOW_GOOGLE_AUTH_MODAL:
      return state.set('showGoogleAuthModal', true);

    case _ActionTypes.default.DISMISS_GOOGLE_AUTH_MODAL:
      return state.set('showGoogleAuthModal', false);

    case _ActionTypes.default.SHOW_SHARE_MODAL:
      return state.set('showShareModal', true);

    case _ActionTypes.default.DISMISS_SHARE_MODAL:
      return state.set('showShareModal', false);

    case _ActionTypes.default.SHOW_GOOGLE_AUTH_ERROR:
      return state.set('showGoogleAuthError', true);

    case _ActionTypes.default.DISMISS_GOOGLE_AUTH_ERROR:
      return state.set('showGoogleAuthError', false);

    case _ActionTypes.default.IMPORT_GOOGLE_DOC_FAILED:
      return state.set('showGoogleDocImportError', true);

    case _ActionTypes.default.DISMISS_GOOGLE_DOC_IMPORT_ERROR:
      return state.set('showGoogleDocImportError', false);

    case _ActionTypes.default.IMPORT_GOOGLE_DOC_IMAGE_UPLOAD_FAILED:
      return state.set('showGoogleDocImportImageUploadError', true);

    case _ActionTypes.default.DISMISS_GOOGLE_DOC_IMPORT_IMAGE_UPLOAD_ERROR:
      return state.set('showGoogleDocImportImageUploadError', false);

    case _ActionTypes.default.SHOW_REVISIONS:
      return state.set('showRevisions', true);

    case _ActionTypes.default.HIDE_REVISIONS:
      return state.set('showRevisions', false);

    case _ActionTypes.default.REVISION_REVERT_SUCCEEDED:
      return state.set('showRevisions', false);

    case _ActionTypes.default.FETCH_REVISIONS_FAILED:
      return state.set('showFetchRevisionsFailedError', true);

    case _ActionTypes.default.DISMISS_FETCH_REVISIONS_FAILED_ERROR:
      return state.set('showFetchRevisionsFailedError', false);

    case _ActionTypes.default.REVISION_REVERT_FAILED:
      return state.merge({
        showRevertFailedError: true,
        showRevisions: false
      });

    case _ActionTypes.default.DISMISS_REVERT_FAILED_ERROR:
      return state.set('showRevertFailedError', false);

    case _ActionTypes.default.SHOW_GOOGLE_DOCS_PICKER:
      return state.set('showGoogleDocsPicker', true);

    case _ActionTypes.default.HIDE_GOOGLE_DOCS_PICKER:
      return state.set('showGoogleDocsPicker', false);

    case _ActionTypes.default.SHOW_GOOGLE_ACCOUNT_SWITCHER:
      return state.set('showGoogleAccountSwitcher', true);

    case _ActionTypes.default.HIDE_GOOGLE_ACCOUNT_SWITCHER:
      return state.set('showGoogleAccountSwitcher', false);

    default:
      return state;
  }
};

exports.default = _default;
module.exports = exports.default;